import React from 'react'
import { Modal, Button } from 'react-bootstrap'

type ConfirmRemoveModalProps = {
    show: boolean
    onHide: () => void
    onConfirm: () => void
    feedName: string
}

const ConfirmRemoveModal: React.FC<ConfirmRemoveModalProps> = ({ show, onHide, onConfirm, feedName }) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Remove Feed</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Are you sure you want to remove the feed <b>{feedName}</b>? This action cannot be undone.</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={onConfirm}>
                    Remove
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ConfirmRemoveModal
